/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//

import chart from './chart';

const __vue_script__ = {
    name: 'StackedBarChart',

    mixins: [chart],

    data() {
        return {
            legend: null,
            processing: false
        };
    },

    methods: {
        initChart() {
            requestAnimationFrame(() => {
                if (!this.$refs['wrapper']) {
                    return;
                }
                this.processing = true;
                const { width, height } = this.$refs['wrapper'].getBoundingClientRect();

                let zDomain = new Set();
                this.data.forEach(d => zDomain.add(this.$i18n.t(`analytics.metrics.${this.zMapper(d)}.title`).toString()));
                zDomain = Array.from(zDomain).sort((a, b) => {
                    const mM = this.$i18n.t(`analytics.metrics.${this.mainMetric}.title`);
                    if (a === mM && b !== mM) {
                        return -1;
                    }

                    if (b === mM && a !== mM) {
                        return 1;
                    }

                    return a - b;
                });

                const chartOptions = {
                    x: this.xMapper,
                    y: this.yMapper,
                    z: d => this.$i18n.t(`analytics.metrics.${this.zMapper(d)}.title`).toString(),
                    j: this.jMapper,
                    width,
                    height,
                    colors: this.colors,
                    withTooltips: (d, index, data) => this.tooltips(d, index, data, this.$i18n.t.bind(this.$i18n)),
                    zDomain,
                    yFormat: 'd',
                    title: this.title,
                };

                if (this.jMapper) {
                    const percents = this.data.map(d => this.jMapper(d, 0, this.data)).filter(Boolean);
                    chartOptions.upper = this.$utils.numbers.quantil(percents, 0.8);

                    const median = this.$utils.numbers.median(percents);
                    chartOptions.lower = Math.floor(median * .2);
                }

                const chart = this.$utils.charts.StackedBarChart(this.data, chartOptions);

                this.$refs['chart'].append(chart);
                this.processing = false;
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stacked-chart chart-widget" }, [
    _c("div", { staticClass: "title" }, [
      _vm.icon ? _c("i", { class: "ic-" + _vm.icon }) : _vm._e(),
      _vm._v(_vm._s(_vm.$t("analytics.charts." + _vm.name + ".title"))),
    ]),
    _c(
      "div",
      { ref: "wrapper", staticClass: "chart-wrapper" },
      [
        _c("loader", { attrs: { status: _vm.loading || _vm.processing } }, [
          _c("div", { ref: "chart", staticClass: "chart" }),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "details" }, [_vm._t("details")], 2),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/charts/StackedBarsChart.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__